import { render } from "./edit-form.vue?vue&type=template&id=b28db4dc"
import script from "./edit-form.vue?vue&type=script&lang=js"
export * from "./edit-form.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__